module.exports = __webpack_public_path__ + "img/ticket_emt.bf31b5d3.png";